// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__1_qmi","social":"styles_social__29iHH","text":"styles_text__2SlYb","agencyLink":"styles_agencyLink__39BXd","tv":"styles_tv__3nGjZ"};